import AirbrakeClient from 'airbrake-js';
import Base64 from 'base-64';

const token = process.env.REACT_APP_ADMIN_TOKEN;
const hash = Base64.encode(token);
const Basic = `Basic ${hash}`;

const header = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Cache-Control': 'no-cache',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type',
  Authorization: `${Basic}`,
  'Access-Control-Max-Age': 86400,
};
const headerNoAuth = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Cache-Control': 'no-cache',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type',
};

const auth = {
  username: 'c0b37b74ec2715a73f21ee03d8e99f8f',
  password: '06ba55da7ac3c1711ef20f8940013821',
};

const internalApiUrl = process.env.REACT_APP_INTERNAL_HOST;

export function callAirBrakeOld(errMsg) {
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    const airbrakes = new AirbrakeClient({
      projectId: 1,
      projectKey: '6189bc98c9bf9f15ec9bf40adf5d0b3e',
      host: 'https://errbit.sla-alacrity.com',
      environment: process.env.REACT_APP_ENVIRONMENT,
    });
    airbrakes.notify(errMsg);
  } else {
    return null;
  }
}

export function callAirBrake(errMsg) {
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    const airbrakes = new AirbrakeClient({
      projectId: 1,
      projectKey: '6189bc98c9bf9f15ec9bf40adf5d0b3e',
      host: 'https://errbit.sla-alacrity.com',
      environment: process.env.REACT_APP_ENVIRONMENT,
      instrumentation: {
        window: false, // Disable automatic window error handling
      },
    });

    const msg = errMsg?.message || errMsg?.toString() || '';

    const IGNORED_JS_ERRORS = [
      'undefined is not an object',
      "undefined is not an object (evaluating 'a.H')",
      'Object.entries requires that input parameter not be null or undefined',
      "Unexpected token '<'",
      'Script error',
      'ResizeObserver loop limit exceeded',
      'ChunkLoadError',
    ];

    const suppressionPatterns = [
      /TypeError/i,
      /undefined is not an object/i,
      /evaluating 'a\.[A-Za-z]+'/i,
    ];

    const isSuppressedByText = IGNORED_JS_ERRORS.some((m) => msg.includes(m));
    const isSuppressedByPattern = suppressionPatterns.some((pattern) => pattern.test(msg));

    if (isSuppressedByText || isSuppressedByPattern) {
      console.debug('[Suppressed JS Error]', msg);

      return;
    }

    // ✅ Send only if it passed all suppression checks
    airbrakes.notify(errMsg);
  }

  return null;
}

export const headers = header;
export const auths = auth;
export const headerNoAuths = headerNoAuth;
export const url = internalApiUrl;
